"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.calculateOfficeUsageSubformUpTo1250EurResults = void 0;
const fullCost_1 = require("./fullCost");
const MAX_HOME_OFFICE_EXPENSES = 125000;
const calculateOfficeUsageSubformUpTo1250EurResults = (inputs) => {
    const { homeOfficeExpenses: homeOfficeExpensesWithoutCap, paidInputTax = 0 } = (0, fullCost_1.calculateOfficeUsageSubformFullCostResults)(inputs);
    const homeOfficeExpenses = Math.min(homeOfficeExpensesWithoutCap, MAX_HOME_OFFICE_EXPENSES);
    return {
        homeOfficeExpenses,
        paidInputTax,
        profitReduction: homeOfficeExpenses + paidInputTax,
    };
};
exports.calculateOfficeUsageSubformUpTo1250EurResults = calculateOfficeUsageSubformUpTo1250EurResults;
//# sourceMappingURL=upTo1250Eur.js.map